import React from 'react'

const ListViewIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.5 0.890625H0.5V3.89062H3.5V0.890625ZM17.5 0.890625H5.5V3.89062H17.5V0.890625ZM0.5 6.89062H3.5V9.89062H0.5V6.89062ZM17.5 6.89062H5.5V9.89062H17.5V6.89062ZM0.5 12.8906H3.5V15.8906H0.5V12.8906ZM17.5 12.8906H5.5V15.8906H17.5V12.8906Z"
                fill="#4161C8"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.5 0.890625H0.5V3.89062H3.5V0.890625ZM17.5 0.890625H5.5V3.89062H17.5V0.890625ZM0.5 6.89062H3.5V9.89062H0.5V6.89062ZM17.5 6.89062H5.5V9.89062H17.5V6.89062ZM0.5 12.8906H3.5V15.8906H0.5V12.8906ZM17.5 12.8906H5.5V15.8906H17.5V12.8906Z"
                fill="#6F7171"
            />
        </svg>
    )
}

export default ListViewIcon